const imagepath = {
     liveimagepath :`https://peekzy.in/backend/public/assets/uploads/`,
     // liveimagepath :`http://localhost:8082/assets/uploads/`,

}



export default imagepath;
